import { defineStore } from 'pinia'

const MODAL_DEFAULT_OPTIONS = {
  backdrop: 'static',
  keyboard: true,
  focus: true,
}

const MODAL_DEFAULT_MODIFIERS = {
  footer: false,
  scrollable: false,
  centered: true,
}

export const useUtilitiesStore = defineStore('utilities', {
  state: () => ({
    modalIsOpen: false,
    modalOptions: MODAL_DEFAULT_OPTIONS,
    modalModifiers: MODAL_DEFAULT_MODIFIERS,
    template: null,
  }),
  actions: {
    openModal(modalOptions = {}, modalModifiers = {}, template = null) {
      this.template = template
      this.modalOptions = { ...this.modalOptions, ...modalOptions }
      this.modalModifiers = { ...this.modalModifiers, ...modalModifiers }
      this.modalIsOpen = true
    },
    closeModal() {
      this.modalIsOpen = false
    },
    clearModal() {
      this.modalOptions = {}
      this.modalModifiers = {}
      this.template = null
    },
    setModalModifiers(modalModifiers) {
      this.modalModifiers = { ...this.modalModifiers, ...modalModifiers }
    },
  },
})
